import { render, staticRenderFns } from "./NominateSecondary.vue?vue&type=template&id=4b438906&"
import script from "./NominateSecondary.vue?vue&type=script&lang=js&"
export * from "./NominateSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports